import { render, staticRenderFns } from "./AwardsSection.vue?vue&type=template&id=411f49e9&scoped=true"
import script from "./AwardsSection.vue?vue&type=script&lang=js"
export * from "./AwardsSection.vue?vue&type=script&lang=js"
import style0 from "./AwardsSection.vue?vue&type=style&index=0&id=411f49e9&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411f49e9",
  null
  
)

export default component.exports